import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { QUERY_KEYS } from "./querykeys";

type RiskDemoResponseType = ResponseType<null>;


function useCreateDemoRiskQuary(organisationId: string,projectId:string) {
  return useQuery<
    AxiosResponseAndError<RiskDemoResponseType>["response"],
    AxiosResponseAndError<RiskDemoResponseType>["error"]
  >({
    queryKey: [QUERY_KEYS.demoRisk],
    queryFn: async () => await ApiRequest.get(`${requestURLs.organisation}/demo-risk/${organisationId}/${projectId}`),
    enabled: false,
    retry:0,
  });
}
export default useCreateDemoRiskQuary;
